import { Event } from '@/app/event-stream';

export const AspectInstanceChangedEventName = 'aspect-instance-changed' as const;
export interface AspectInstanceChangedEvent {
  instanceId: string;
}

export type AspectEvent = Event<typeof AspectInstanceChangedEventName, AspectInstanceChangedEvent>;
